import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import jquery from 'jquery';
import { Table, message, Tooltip, Icon, Modal, Tabs } from 'antd';
import UpdateDepartment from './UpdateDepartment';
import PendingDeptList from './PendingDeptList';
import PreviewModal from './PreviewModal';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExportModal from './ExportModal';
import SetDirector from './SetDirector';
import SetManager from './SetManager';
import CommentLog from './CommentLog';
import UserInfo from './UserInfo';
import SideNav from '../SideNav';
import SetPCRC from './SetPCRC';
import Filter from './Filter';
import Cooperation from '../UpdateJinshiCooperation';
import { saveParams, saveSearchParams } from '../../../actions/departmentActions';
import { saveParams as saveNoticeParams } from '../../../actions/noticeActions';
import fp from '../../../utils/fp';
import cf from "../../../utils/cf";
import SetManagerUser from './SetManagerUser';
import CRCpeople from '../hospitalInfo/CRCpeople';
import DepartmentGradeConfig from './DepartmentGradeConfig';
import DepartmentGradeLog from './DepartmentGradeLog';
import './index.less';
import setDefaultValue from '../../shared/setDefaultValue';

class DepartmentInfo extends Component {
    state = {
        arry: [],
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        data: [],
        isAdd: false,
        loading: false,
        clearArry: false,
        selectedRowKeys: [],
        showCommentLog: false,
        crcFlag: false,
        activeTab: 'cooperate',
        workDayList: [],
    }

    componentDidMount() {
        const { feedBack, pagination = {}, searchParams, params, showCommentLog = false } = this.props;
        if (feedBack) {
            this.setState({ pagination, searchParams, showCommentLog });
        }
        if( params && !feedBack ){
            this.setState({
                searchParams:{
                    ...searchParams,
                    ...params,
                },
            })
        }
        this.judgeCrcHospotial();
        this.getWorkDayList();
    }

    componentWillUnmount() {
        this.props.saveNoticeParams({ 
            requestPayManagerUserId: undefined,
            requestPayManagerUserName: undefined,
            jsChargeUserId: undefined,
            userName: undefined,
        });
    }

    judgeCrcHospotial = () => {
        const options = {
            method: 'POST',
            url: API_URL.hospital.judgeCrcHospotial,
            data: { },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    crcFlag: res.crcFlag,
                });
            },
        };
        $.sendRequest(options);
    }

    getWorkDayList = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.getWorkDayList,
            data: { dayNum: 10 },
            dataType: 'json',
            doneResult: res => {
                if (res.success && res.data) {
                    this.setState({ workDayList: res.data });
                }
            },
        });
    }

    /**
     * 判断当前日期是否在当月前N个工作日之内
     */
    isInWorkDayList = () => {
        const { workDayList } = this.state;
        if (!workDayList || workDayList.length === 0) {
            return false;
        }
        const today = new Date();
        const dayOfMonth = today.getDate();
        return workDayList.indexOf(dayOfMonth) !== -1;
    }

    loadData = () => {
        const { pagination, sortParams, searchParams } = this.state;
        const { current, pageSize } = pagination;
        const { areaParams = {}, hasCheckedArea, hospitalIds = [], courtyardArea, ...rest } = searchParams;
        const params = { ...rest, ...areaParams };
        hospitalIds.forEach((item, index) => {
            params[`ids[${index}]`] = item.key;
        });
        ( courtyardArea || [] ).map((item, index) =>{
            params[`ids[${index}]`] = item
        });
        delete params.cityId;
        this.setState({ loading: true }); 
        const options = {
            method: 'POST',
            url: `${API_URL.hospital.queryDepartmentListByInves}`,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...params,
            },
            dataType: 'json',
            doneResult: res => {
                const tableDom = ReactDOM.findDOMNode(this.tableRef);
                const containDom = jquery(tableDom).find('.ant-table-scroll .ant-table-body')[0];
                containDom.scrollTop = 0;

                const { arry, clearArry } = this.state;
                const { datas = [], data: { canAddDept } } = res;
                pagination.total = res.totalCount;

                let newArry;
                const newSelectedRowKeys = [];
                if (clearArry) {
                    newArry = arry.filter(item => datas.some(innerItem => innerItem.hospitalDepartmentId == item));
                } else {
                    newArry = arry;
                }
                newArry.forEach(item => {
                    const selectData = datas.find(innerItem => innerItem.hospitalDepartmentId == item);
                    if (selectData) {
                        newSelectedRowKeys.push(selectData.index);
                    }
                });

                this.setState({
                    pagination,
                    data: datas,
                    arry: newArry,
                    loading: false,
                    isAdd: canAddDept === 'TRUE',
                    selectedRowKeys: newSelectedRowKeys,
                });
            }
        };
        $.sendRequest(options);
    }

    
    search = (params) => {
        const { pagination } = this.state;
        const searchParams = {...params};
        this.setState({
            searchParams,
            pagination: {
                ...pagination,
                current: 1,
            },
            clearArry: true,
        }, () => {
            const { feedBack } = this.props;
            if (feedBack) {
                this.props.saveParams({ feedBack: false });
                this.props.saveSearchParams({
                    pagination: {},
                    searchParams: {},
                });
            }
            this.loadData();
        });
    }

    export = (searchParams) => {
        const { areaParams = {}, hasCheckedArea, hospitalIds = [], ...rest } = searchParams;
        const params = { ...rest, ...areaParams };
        hospitalIds.forEach((item, index) => {
            params[`ids[${index}]`] = item.key;
        });
        delete params.cityId;
        this.exportModalRef.show(params);
    }

    delete = record => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定要删除吗？",
            onOk: () => {
                const { hospitalId, hospitalDepartmentId, hospitalDepartmentEnterpriseId } = record;
                const options = {
                    method: 'POST',
                    url: API_URL.hospital.deleteHospitalDepartment,
                    data: {
                        hospitalId,
                        enterpriseId: 1,
                        hospitalDepartmentId,
                        hospitalDepartmentEnterpriseId,
                    },
                    dataType: 'json',
                    doneResult: res => {
                        message.success(res.success);
                        this.loadData();
                    }
                };
                $.sendRequest(options);
            },
        });
    }

    /**
     * 判断当前是否为历史固化数据查询
     */
    isHistoricalData = () => {
        const { date } = this.state.searchParams;
        if (date) {
            const now = new Date();
            const curYearMonth = now.getFullYear() * 100 + (now.getMonth() + 1);
            const dateYearMonth = parseInt(date.replace('-', ''));
            return dateYearMonth < curYearMonth;
        }
        return false;
    }

    getColumns = () => {
        const { userId } = sessionStorage;
        const { crcFlag } = this.state;
        const columns = [];
        columns.push({
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            fixed: 'left',
            width: 60,
        }, {
            title: '医院',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            fixed: 'left',
            width: 160,
            sorter: true,
            sortType: 'common',
        }, {
            title: '院区',
            dataIndex: 'courtyardArea',
            key: 'courtyardArea',
            fixed: 'left',
            width: 80,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        }, {
            title: '省',
            dataIndex: 'hospitalProvince',
            key: 'hospitalProvince',
            sorter: true,
            sortType: 'common',
            width: 80,
        }, {
            title: '市',
            dataIndex: 'hospitalCity',
            key: 'hospitalCity',
            sorter: true,
            sortType: 'common',
            width: 80,
        }, {
            title: '县级行政区（如无则默认为上级行政单位）',
            dataIndex: 'hospitalCounty',
            key: 'hospitalCounty',
            width: 80,
        }, {
            title: '科室',
            dataIndex: 'departmentLocalName',
            key: 'departmentLocalName',
            sorter: true,
            sortType: 'common',
            width: 100,
        }, {
            title: '行政负责人',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            sorter: true,
            sortType: 'common',
            width: 100,
        }, {
            title: '行政负责人职务',
            dataIndex: 'doctorPosition',
            key: 'doctorPosition',
            sorter: true,
            sortType: 'common',
            width: 100,
        }, {
            title: '行政负责人手机号码',
            dataIndex: 'userMobile',
            key: 'userMobile',
            sorter: true,
            sortType: 'common',
            width: 100,
        }, {
            title: '行政负责人固定电话',
            dataIndex: 'userTelphone',
            key: 'userTelphone',
            sorter: true,
            sortType: 'common',
            width: 100,
        }, {
            title: '行政负责人邮箱',
            dataIndex: 'userEmail',
            key: 'userEmail',
            sorter: true,
            sortType: 'common',
            width: 140,
        });
        if (!crcFlag) {
            columns.push({
                title: 'PCRC(临床试验年限(月))',
                dataIndex: 'mainCrcNameYears',
                key: 'mainCrcNameYears',
                width: 100,
                render: (text, record) => {
                    const { mainCrcList } = record;
                    const len = mainCrcList ? mainCrcList.length : 0;
                    return (
                        <span>
                            {
                                (mainCrcList || []).map((item, index) => {
                                    const { userId, workingLife, userCompellation } = item;
                                    return (
                                        <a key={userCompellation} onClick={() => this.showUserInfo(userId)}>
                                            {userCompellation}({workingLife || 0}){index < len - 1 ? '，' : ''}
                                            {index < len - 1 ? <br /> : ''}
                                        </a>
                                    )
                                })
                            }
                        </span>
                    )
                }
            }, {
                title: '是否常选组长单位',
                dataIndex: 'oftenGroupLeaderUnit',
                key: 'oftenGroupLeaderUnit',
                width: 100,
            }, {
                title: '机构或科室是否有指定津石以外SMO',
                dataIndex: 'hasOtherSmo',
                key: 'hasOtherSmo',
                width: 100,
                render: text => text === null || text === undefined ? '' : (text == 1 ? '是' : '否'),
            }, {
                title: '其他SMO公司',
                dataIndex: 'otherSmoCompanyNames',
                key: 'otherSmoCompanyNames',
                width: 160,
            }, {
                title: '本月科室档位分类',
                dataIndex: 'currentMonthGradeCategoryShow',
                key: 'currentMonthGradeCategoryShow',
                width: 100,
            }, {
                title: '本月科室档位',
                dataIndex: 'currentMonthGradeShow',
                key: 'currentMonthGradeShow',
                sorter: true,
                sortType: 'common',
                width: 100,
            }, {
                title: '上月科室档位分类',
                dataIndex: 'lastMonthGradeCategoryShow',
                key: 'lastMonthGradeCategoryShow',
                width: 100,
            }, {
                title: '上月科室档位',
                dataIndex: 'lastMonthGradeShow',
                key: 'lastMonthGradeShow',
                sorter: true,
                sortType: 'common',
                width: 100,
            }, {
                title: '是否是黑名单',
                dataIndex: 'isBlacklist',
                key: 'isBlacklist',
                width: 80,
                render: text => text === null || text === undefined ? '' : (text == 1 ? '是' : '否'),
            }, {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
                width: 160,
            }, {
                title: '参与的项目数量',
                children: [{
                    title: '所有项目',
                    dataIndex: 'invesNum',
                    key: 'invesNum',
                    sorter: true,
                    sortType: 'common',
                    width: 100,
                }, {
                    title: '进行中项目',
                    dataIndex: 'underwayInveNum',
                    key: 'underwayInveNum',
                    sorter: true,
                    sortType: 'common',
                    width: 100,
                }]
            }, {
                title: '筛选病例数',
                children: [{
                    title: '所有项目',
                    dataIndex: 'filterAccount',
                    key: 'filterAccount',
                    sorter: true,
                    sortType: 'common',
                    width: 100,
                }, {
                    title: '进行中项目',
                    dataIndex: 'underwayFilterAccount',
                    key: 'underwayFilterAccount',
                    sorter: true,
                    sortType: 'common',
                    width: 100,
                }]
            },  {
                title: '随机病例数',
                children: [{
                    title: '所有项目',
                    dataIndex: 'randomAccount',
                    key: 'randomAccount',
                    sorter: true,
                    sortType: 'common',
                    width: 100,
                }, {
                    title: '进行中项目',
                    dataIndex: 'underwayRandomAccount',
                    key: 'underwayRandomAccount',
                    sorter: true,
                    sortType: 'common',
                    width: 100,
                }]
            }, {
                title: '入组周速率',
                dataIndex: 'weekGroupSpeed',
                key: 'weekGroupSpeed',
                sorter: true,
                sortType: 'common',
                width: 100,
            }, {
                title: '入组月速率',
                dataIndex: 'monthGroupSpeed',
                key: 'monthGroupSpeed',
                sorter: true,
                sortType: 'common',
                width: 100,
            }, {
                title: '与津石是否有合作',
                dataIndex: 'userCooperation',
                key: 'userCooperation',
                width: 80,
                render: (text, record) => {
                    const { systemCooperation } = record;
                    if (systemCooperation == 1) {
                        return '是';
                    } else {
                        return text == 1 ? '是' : '否';
                    }
                }
            })
        }
        
        columns.push({
            title: '科室leader姓名',
            dataIndex: 'jsChargeUserCompellation',
            key: 'jsChargeUserCompellation',
            width: 80,
            render: (text, record) => {
                return record.jsChargeUserWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text; 
            },
        }, {
            title: '科室leader工号',
            dataIndex: 'jsChargeEmployeeCode',
            key: 'jsChargeEmployeeCode',
            width: 80,
            render: (text, record) => {
                return record.jsChargeUserWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text; 
            },
        }, {
            title: '科室leader手机号',
            dataIndex: 'jsChargeUserTelphone',
            key: 'jsChargeUserTelphone',
            width: 100,
            render: (text, record) => {
                return record.requestPayManagerWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text; 
            },
        }, {
            title: '科室leader邮箱',
            dataIndex: 'jsChargeUserEmail',
            key: 'jsChargeUserEmail',
            width: 140,
            render: (text, record) => {
                return record.requestPayManagerWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text; 
            },
        });
        if (!crcFlag) {
            columns.push({
                title:(
                    <span>
                        现任CRC人数
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'取职位是“临床协调员”的现任CRC'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'departmentCrcCount',
                key: 'departmentCrcCount',
                width: 80,
                render: (text, record) => {
                    return <a onClick={() => this.showCRCpeople(record)}>{text}</a>
                }
            }, {
                title:(
                    <span>
                        临床试验操作经验平均值（月）
                        <Tooltip overlayStyle={{ width: 160 }} placement="top" title={'CRC临床试验经验年限合计/CRC人数'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'avgWorkLife',
                key: 'avgWorkLife',
                width: 100,
            }, {
                title: '是否从中心请款',
                dataIndex: 'isRequestFromSite',
                key: 'isRequestFromSite',
                width: 80,
            });
        }

        columns.push({
            title: '有无中心药房',
            dataIndex: 'centerPharmacy',
            key: 'centerPharmacy',
            width: 100,
            render: text => String(text) === 'true' ? '有' : (String(text) === 'false' ? '无' : '')
        });
        if (!crcFlag) {
            columns.push({
                title: <span>
                    有无破盲风险
                    <Tooltip overlayClassName="downloadSite" placement="top" title={<div>
                        <span style={{ color: '#dad20b' }}>破盲风险判断</span><br/>
                        1、医院有中心药房：CRC可以直接接触全部药物，确定有破盲风险；<br/>
                        2、医院有中心药房：CRC仅签字取药，医院主管自主判断是否有破盲风险；<br/>
                        3、医院有中心药房，科室也可存放药物：CRC可以直接接触全部药物，确定有破盲风险；<br/>
                        4、医院有中心药房，科室也可存放药物：CRC仅签字取药，医院主管自主判断是否有破盲风险；<br/>
                        5、医院有中心药房，科室也可存放药物：同科室有交叉项目，医院主管自主判断是否有破盲风险；<br/>
                        6、医院无中心药房，确认药物存放环境：CRC可以直接接触全部药物，确定有破盲风险；<br/>
                        7、医院无中心药房，确认药物存放环境：CRC仅签字取药，医院主管自主判断是否有破盲风险；<br/>
                        8、医院无中心药房，确认药物存放环境：同科室有交叉项目，医院主管自主判断是否有破盲风险；
                        </div>}>
                        <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                    </Tooltip>
                </span>,
                dataIndex: 'unblindingRisk',
                key: 'unblindingRisk',
                width: 120,
                render: text => String(text) === 'true' ? '有' : (String(text) === 'false' ? '无' : '')
            }, {
                title: '破盲原因',
                dataIndex: 'unblindingReasonShow',
                key: 'unblindingReasonShow',
                width: 120,
            }, {
                title: '破盲风险等级',
                dataIndex: 'unblindingRiskLevelShow',
                key: 'unblindingRiskLevelShow',
                width: 100,
            });
        }

        columns.push({
            title: '科室请款负责人',
            dataIndex: 'requestPayManagerUserInfo',
            key: 'requestPayManagerUserInfo',
            width: 120,
            render: (text, record) => {
                return record.requestPayManagerWorkStatus == 'LEFT' ? <span style={{ color: '#999999' }}>{text}</span> : text;
            },
        });

        // 历史固化数据不显示操作栏
        if (!this.isHistoricalData()) {
        columns.push({
            title: '操作',
            dataIndex: 'option',
            key: 'option',
            fixed:'right',
            width: 140,
            render:(text, record) => {
                // isCharge：医院主管、医院负责人；isDirector: 医院主管
                const { isCharge, isDirector, depJsChargeUserId, systemCooperation, areaChargeUserId, isClinicalBO } = record;
                const isDepDirector = userId == depJsChargeUserId;
                const { curRole } = sessionStorage;
                const { crcFlag } = this.state;
                // return (
                //     <span>
                //         {
                //             (isCharge === 1 || isDepDirector) &&
                //             <span>
                //                 <a onClick={() => this.update(record, 'edit')}>修改</a>
                //                 <span className="ant-divider" />
                //             </span>
                //         }
                //         {
                //             (isCharge === 1) &&
                //             <span>
                //                 <Popconfirm title='确定要删除吗?' onConfirm={() => this.delete(record)} okText="确定" cancelText="取消">
                //                     <a>删除</a>
                //                 </Popconfirm>
                //                 <span className="ant-divider" />
                //             </span>
                //         }
                //         {
                //             (isCharge === 1 || isDepDirector) &&
                //             <span>
                //                 <a onClick={() => this.setManager(record)}>配置行政负责人</a>
                //                 <span className="ant-divider" />
                //             </span>
                //         }
                //         {
                //             isDirector === 1 &&
                //             <span>
                //                 <a onClick={() => this.setPCRC(record)}>配置PCRC</a>
                //                 <span className="ant-divider" />
                //             </span>
                //         }
                //         {
                //             ((isCharge === 1 || isDirector === 1) && systemCooperation == 0) &&
                //             <span>
                //                 <a onClick={() => this.showCooperation(record)}>修改津石合作情况</a>
                //                 <span className="ant-divider" />
                //             </span>
                //         }
                //         {
                //             (isDirector === 1 || areaChargeUserId == userId) &&
                //             <span>
                //                 <a onClick={() => this.setDirector(record)}>配置科室leader</a>
                //                 <span className="ant-divider" />
                //             </span>
                //         }
                //         {
                //             (fp.contains(curRole, ['BO', 'CSAL']) || areaChargeUserId == userId) &&
                //             <span>
                //                 <a onClick={() => this.setManagerUser(record)}>配置科室请款负责人</a>
                //             </span>
                //         }
                //         {!crcFlag && <span className="ant-divider" />}
                //         {!crcFlag && <a onClick={() => this.showPreviewModal(record)}>项目明细</a>}
                //         {!crcFlag && <span className="ant-divider" />}
                //         {!crcFlag && <a onClick={() => this.comment({...record, isDepDirector})}>点评信息</a>}
                //     </span>
                // )
                const operationCorrespondRoles = new Map([
                    ['edit', {
                        name: '修改',
                        display: isCharge === 1 || isDepDirector || areaChargeUserId == userId,
                        editable: true,
                        event: () => this.update(record, 'edit'),
                        roles: ['*'],
                    }],
                    ['delete', {
                        name: '删除',
                        display: isCharge === 1,
                        editable: true,
                        event: () => this.delete(record),
                        roles: ['*'],
                    }],
                    ['setManager', {
                        name: '配置行政负责人',
                        display: isCharge === 1 || isDepDirector,
                        editable: true,
                        event: () => this.setManager(record),
                        roles: ['*'],
                    }],
                    ['setPCRC', {
                        name: '配置PCRC',
                        display: isDirector === 1,
                        editable: true,
                        event: () => this.setPCRC(record),
                        roles: ['*'],
                    }],
                    ['editCooperation', {
                        name: '修改津石合作情况',
                        display: (isCharge === 1 || isDirector === 1) && systemCooperation == 0,
                        editable: true,
                        event: () => this.showCooperation(record),
                        roles: ['*'],
                    }],
                    ['setDirector', {
                        name: '配置科室leader',
                        display: isDirector === 1 || areaChargeUserId == userId,
                        editable: true,
                        event: () => this.setDirector(record),
                        roles: ['*'],
                    }],
                    ['setManagerUser', {
                        name: '配置科室请款负责人',
                        display: fp.contains(curRole, ['BO', 'CSAL']) || areaChargeUserId == userId,
                        editable: true,
                        event: () => this.setManagerUser(record),
                        roles: ['*'],
                    }],
                    ['preview', {
                        name: '项目明细',
                        display: !crcFlag,
                        editable: true,
                        event: () => this.showPreviewModal(record),
                        roles: ['*'],
                    }],
                    ['comment', {
                        name: '点评信息',
                        display: !crcFlag,
                        editable: true,
                        event: () => this.comment({...record, isDepDirector}),
                        roles: ['*'],
                    }],
                    ['gradeConfig', {
                        name: '科室档位配置',
                        display: this.isInWorkDayList() && (areaChargeUserId == userId || fp.contains(curRole, ['PML']) || sessionStorage.isClinicalBO === 'true' || isDepDirector),
                        editable: true,
                        event: () => this.departmentGradeConfigRef.show(record),
                        roles: ['*'],
                    }],
                    ['gradeLog', {
                        name: '科室档位更新日志',
                        display: (areaChargeUserId == userId || fp.contains(curRole, ['PML']) || sessionStorage.isClinicalBO === 'true' || isDepDirector),
                        editable: true,
                        event: () => this.departmentGradeLogRef.show(record),
                        roles: ['*'],
                    }],
                ]);
                return (
                    <span className="operateBarLineWrap">
                        {   
                            fp.compose(
                                fp.curry(cf.operationAuthByRole)( 
                                    index => <span key={index} className="ant-divider" />
                                ),
                                fp.curry(setDefaultValue)('-'),
                                fp.filter(i => !!i),
                                // 获取角色对应操作
                                fp.curry(cf.authDomList)(operationCorrespondRoles)
                            )(curRole)
                        }
                    </span>
                );
            }
        });
        } // end !isHistoricalData

        return columns;
    }

    getDataSource = () => {
        const { data, pagination, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => ({
            index: (current - 1) * pageSize + index + 1,
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            pagination,
            sortParams,
            clearArry: false,
        }, () => {
            this.loadData();
        });
    }

    comment = (record) => {
        const { pagination, searchParams } = this.state;
        const { isCharge, isDepDirector, hospitalId, hospitalName, departmentLocalName, hospitalDepartmentId } = record;
        const params = {
            hospitalId,
            hospitalName,
            hospitalDepartmentId,
            isAdd: isCharge === 1 || isDepDirector,
            departmentName: departmentLocalName,
        }
        this.props.saveParams({ params });
        this.props.saveSearchParams({
            pagination,
            searchParams,
        })
        location.href = '#/hospital/commentInfo';
    }

    showPreviewModal = record => {
        this.previewModalRef.show(record);
    }

    showUserInfo = (userId) => {
        this.userInfoRef.show(userId);
    }

    update = (record, type) => {
        this.updateRef.show(record, type);
    }

    setManager = record => {
        this.setManagerRef.show(record);
    }

    setDirector = record => {
        this.setDirectorRef.show(record);
    }
    
    setManagerUser = record => {
        this.setManagerUserRef.show(record);
    }
 
    setPCRC = record => {
        this.setPCRCRef.show(record);
    }

    showCRCpeople = record => {
        this.CRCpeopleRef.show(record);
    }

    onSelectChange = (record, selected) => {
        const { selectedRowKeys, arry } = this.state;
        if (selected) {
            const isExist = selectedRowKeys.some(item => item == record.index);
            !isExist && selectedRowKeys.push(record.index);
            const isIdExist = arry.some(item => item == record.hospitalDepartmentId);
            !isIdExist && arry.push(record.hospitalDepartmentId);
        } else {
            let idx;
            selectedRowKeys.forEach((item, index) => {
                if (record.index == item) {
                    idx = index;
                }
            });
            (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

            // 删除已存在的id
            let idIdx;
            arry.forEach((item, index) => {
                if (record.hospitalDepartmentId == item) {
                    idIdx = index;
                }
            });
            (idIdx || (!idIdx && idIdx === 0)) && arry.splice(idIdx, 1);
        }
        this.setState({
            arry,
            selectedRowKeys,
        });
    }

    onSelectAllChange = (selected, selectedRows, changeRows) => {
        const { arry, selectedRowKeys } = this.state;
        if (selected) {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                !(idx || (!idx && idx === 0)) && selectedRowKeys.push(item.index);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item.hospitalDepartmentId) {
                        idIdx = index;
                    }
                });
                !(idIdx || (!idIdx && idIdx === 0)) && arry.push(item.hospitalDepartmentId);
            });
        } else {
            changeRows.forEach(item => {
                let idx;
                selectedRowKeys.forEach((selectItem, index) => {
                    if (selectItem == item.index) {
                        idx = index;
                    }
                });
                (idx || (!idx && idx === 0)) && selectedRowKeys.splice(idx, 1);

                let idIdx;
                arry.forEach((arryItem, index) => {
                    if (arryItem == item.hospitalDepartmentId) {
                        idIdx = index;
                    }
                });
                (idIdx || (!idIdx && idIdx === 0)) && arry.splice(idIdx, 1);
            });
        }
        this.setState({
            arry,
            selectedRowKeys,
        });
    }

    showCommentLog = (showCommentLog) => {
        this.setState({ showCommentLog });
    }

    showCooperation = (record) => {
        this.cooperationRef.show(record);
    }

    onTabChange = (key) => {
        this.setState({ activeTab: key });
    }

    render() {
        const { loading, pagination, searchParams, selectedRowKeys, arry, isAdd, showCommentLog, crcFlag,
            activeTab } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onSelect: this.onSelectChange,
            onSelectAll: this.onSelectAllChange,
        };
        return (
            <div className="content">
                <SideNav selectKey='departmentDetail' />
                <div className="main" style={{ display: showCommentLog ? 'none' : 'block' }}>
                    <Tabs activeKey={activeTab} onChange={this.onTabChange} type="card">
                        <Tabs.TabPane tab="合作医院科室" key="cooperate">
                            <Filter
                                isAdd={isAdd}
                                crcFlag={crcFlag}
                                search={this.search}
                                export={this.export}
                                update={this.update}
                                showCommentLog={this.showCommentLog}
                                params={this.props.params}
                                searchParams={searchParams}
                            />
                            <Table
                                ref={el => this.tableRef = el}
                                rowSelection={rowSelection}
                                columns={this.getColumns()}
                                dataSource={this.getDataSource()}
                                rowKey={record => record.index}
                                loading={loading}
                                scroll={{ x: crcFlag ? 1000 : 2840 }}
                                onChange={this.handleTableChange}
                                pagination={pagination}
                                className="hospitalTableStyle"
                            />
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="待合作医院科室" key="pending">
                            <PendingDeptList />
                        </Tabs.TabPane>
                    </Tabs>
                </div>
                { showCommentLog && <CommentLog showCommentLog={this.showCommentLog} />}
                <UserInfo ref={el => this.userInfoRef = el} />
                <ExportModal ref={el => this.exportModalRef = el} arry={arry} />
                <SetPCRC ref={el => this.setPCRCRef = el} loadData={this.loadData} />
                <PreviewModal ref={el => this.previewModalRef = el} params={searchParams} />
                <SetManager ref={el => this.setManagerRef = el} loadData={this.loadData} />
                <SetDirector ref={el => this.setDirectorRef = el} loadData={this.loadData} />
                <SetManagerUser ref={el => this.setManagerUserRef = el} loadData={this.loadData} />
                <UpdateDepartment ref={el => this.updateRef = el} loadData={this.loadData} />
                <Cooperation ref={el => this.cooperationRef = el} type="DEPARTMENT" loadData={this.loadData} />
                <CRCpeople ref={el => this.CRCpeopleRef = el} />
                <DepartmentGradeConfig ref={el => this.departmentGradeConfigRef = el} loadData={this.loadData} />
                <DepartmentGradeLog ref={el => this.departmentGradeLogRef = el} />
            </div>
        );
    }
}

const mapStateToDispatch = state => ({
    feedBack: state.departmentState.feedBack,
    showCommentLog: state.departmentState.showCommentLog,
    pagination: state.departmentState.pagination,
    searchParams: state.departmentState.searchParams,
    params: state.noticeState.params,
});

const mapDispatchToProps = (dispatch) => {
    return {
        saveNoticeParams: params => dispatch(saveNoticeParams(params)),
        saveParams: params => dispatch(saveParams(params)),
        saveSearchParams: params => dispatch(saveSearchParams(params)),
    }
}

export default connect(mapStateToDispatch, mapDispatchToProps)(DepartmentInfo);


// WEBPACK FOOTER //
// ./src/components/hospital/departmentInfo/index.js